import { NewPasswordService } from '../_services/NewPasswordService';
import { PasswordResetService } from '../_services/PasswordResetService';

export class PasswordResetStore {
    private _passwordResetService: PasswordResetService;
    private _newPasswordService: NewPasswordService;

    public constructor() {
        this._passwordResetService = new PasswordResetService('nil');
        this._newPasswordService = new NewPasswordService('nil');
    }

    public resetPassword(email: string): Promise<any> {
        return this._passwordResetService.postResetEmail(email);
    }

    public setNewPassword(email: string, reset_token: string, new_password: string): Promise<any> {
        return this._newPasswordService.postNewPassword(email, reset_token, new_password);
    }
}



// WEBPACK FOOTER //
// ./src/_stores/PasswordResetStore.tsx